export default "__VITE_ASSET__98c0e8cd__"